import { getUserData } from '@/core/auth/utils'

const updateMetaForRole = to => {
    const permissions = getUserData()?.permissions || []
    const hasForemanPermission = permissions.includes('foreman.list')

    to.meta.isForeman = hasForemanPermission

    return true
}

export default [
    // Redirect для обратной совместимости
    {
        path: '/stop-lists',
        redirect: '/menu-management/stop-lists',
    },
    // Общий layout для menu-management с nested routes
    {
        path: '/menu-management',
        component: () => import('./views/MenuManagementLayout.vue'),
        redirect: '/menu-management/stop-lists',
        children: [
            // Стоп-листы (существующий функционал)
            {
                path: 'stop-lists',
                name: 'StopLists',
                meta: {
                    permission: ['stop-lists.list', 'foreman.list'],
                    activeTab: 'stop-lists',
                    isForeman: false,
                },
                beforeEnter: (to, from, next) => {
                    updateMetaForRole(to)
                    next()
                },
                component: () => import('./views/StopListsContent.vue'),
            },
            // Управление печатью (новый функционал)
            {
                path: 'print',
                name: 'PrintManagement',
                meta: {
                    permission: ['print-management.list', 'foreman.list'],
                    activeTab: 'print',
                    isForeman: false,
                },
                beforeEnter: (to, from, next) => {
                    updateMetaForRole(to)
                    next()
                },
                component: () => import('./views/PrintManagementContent.vue'),
            },
        ],
    },
]
